import styles from './Discussions.module.css'

/** "(bell) Team asked · 40m ago" on a card or a waiting row (`teamAskedLine` — the team was asked and
 *  has not answered yet). The bell is a stroke glyph, not an emoji. */
const TeamAsked: React.VFC<{ line: string }> = ({ line }) => (
  <span className={styles.teamAsked}>
    <svg
      className={styles.teamAskedBell}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.7 21a2 2 0 0 1-3.4 0" />
    </svg>
    {line}
  </span>
)

export default TeamAsked
